var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"loading-container",attrs:{"src":require("@/assets/loading.svg"),"alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }